import axios from 'axios';
import { signOutFirebase, getAccessToken, refreshAccessToken } from 'services/auth';
import { gaEvent } from 'services/ga';
import { isServer, settings } from '../settings';
import { documentSetCookie } from '../cookie';

const userService = (accessToken) =>
  axios.create({
    baseURL: (isServer && settings.API_SERVICE_INTERNAL_URL_USER) || settings.API_SERVICE_URL_USER,
    timeout: isServer ? 2000 : 10000,
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });

export const loginDumpert = (username, password) =>
  userService(null).post('/login', { username, password });

export const loginDumpertOTP = (username, password, otp) =>
  userService(null).post('/login-like-a-boss', { username, password, otp });

export const userSettings = (username) => userService(null).post('/settings', { username });

export const registerDumpertUser = (data) => userService(null).post('/register', data);

export const userSendConfirmEmail = (data) => userService(null).post('/send-confirm-email', data);

export const userConfirmEmail = (data) => userService(null).post('/confirm-email', data);

export const userRecoverPassword = (data) => userService(null).post('/recover-password', data);

export const userResetPassword = (data) => userService(null).post('/reset-password', data);

export const getUser = async () => userService(await getAccessToken()).post('/user');

export const deleteUser = async (data) =>
  userService(await getAccessToken()).post('/user-delete', data);

export const userChangeName = async (data) =>
  userService(await getAccessToken()).post('/change-name', data);

export const userChangeUsername = async (data) =>
  userService(await getAccessToken()).post('/change-username', data);

export const userChangeBirthDate = async (data) =>
  userService(await getAccessToken()).post('/change-birthdate', data);

export const userChangePassword = async (data) =>
  userService(await getAccessToken()).post('/change-password', data);

export const userChangeEmail = async (data) =>
  userService(await getAccessToken()).post('/change-email-request', data);

export const changeEmail = (data) => userService(null).post('/change-email', data);

export const submitTipForm = (data) => {
  return userService(null).post('/linktip/', data);
};

export const userLogout = () => {
  signOutFirebase();
  documentSetCookie('access_token', '');
  gaEvent('dmp_user', 'logout');
};

export const userUpdateAccessToken = () => {
  documentSetCookie('access_token', '');
  refreshAccessToken().then(() => window.location.reload());
};

export const submitContactForm = async (data) => {
  return userService(await getAccessToken()).put('/contactform', data);
};

export const getTotalUsers = async () => {
  return userService(await getAccessToken()).get('/stats/users');
};
